import { Component, inject, input, InputSignal } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { FormGroup } from '@angular/forms';
import { FormErrorSupportService } from '../../../services/support/form-error-support/form-error-support.service';
import { AppConfigService } from '../../../services/app-config.service';

@Component({
  selector: 'aw-reveal-form-errors-button',
  imports: [ButtonComponent],
  templateUrl: './reveal-form-errors-button.component.html',
})
export class RevealFormErrorsButtonComponent {
  form: InputSignal<FormGroup> = input.required();
  scrollToFirstError: InputSignal<boolean> = input(true);
  private readonly formErrors: FormErrorSupportService = inject(
    FormErrorSupportService
  );
  private readonly configService: AppConfigService = inject(AppConfigService);

  public revealFormErrors(): void {
    this.form().markAllAsTouched();
    if (this.configService.get().general.stage !== 'PROD') {
      console.warn(this.formErrors.findErrors(this.form()));
    }
    if (this.scrollToFirstError()) {
      setTimeout(() => {
        this.scrollToError();
      }, 0);
    }
  }

  private scrollToError(): void {
    const errors = document.getElementsByTagName('aw-error-message');
    if (errors.length > 0) {
      const yOffset = -256;
      const yPosition =
        errors[0].getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ behavior: 'smooth', top: yPosition });
    }
  }
}
